<template>
    <span :class="$style.wrapper">
        <popup-menu :width="550" vertical-flow="down">
            <template #handle>
                (<span class="hyperlink">View History</span>)
            </template>

            <component :is="tableComponent" :data="data" />
        </popup-menu>
    </span>
</template>

<script>
import PopupMenu from 'larasnap/assets/vue/support/popup_menu/PopupMenu.vue';
import FinanceTable from './components/types/FinanceTable.vue';
import PropertyTable from './components/types/PropertyTable.vue';
import capitalize from 'lodash-es/capitalize';

//let counter = 0;

export default {
    components: { PopupMenu, FinanceTable, PropertyTable },
    props: {
        data: Object,
    },
    computed: {
        tableComponent() {
            return capitalize(this.data.type) + 'Table';
        },
    },
    mounted() {
        //if (++counter === 1) $(this.$el).find('.hyperlink').click();
    },
};
</script>

<style lang="scss" module>
/* .wrapper {
} */
</style>

<style lang="scss" scoped>
.popup-menu-wrapper {
    display: inline;
}
</style>
